import { render, staticRenderFns } from "./AdvertisingTiles.vue?vue&type=template&id=4d85035e&scoped=true&"
import script from "./AdvertisingTiles.vue?vue&type=script&lang=js&"
export * from "./AdvertisingTiles.vue?vue&type=script&lang=js&"
import style0 from "./AdvertisingTiles.vue?vue&type=style&index=0&id=4d85035e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d85035e",
  null
  
)

export default component.exports